<script setup lang="ts">
import { computed, h } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useTranslations } from '@/composables/useTranslations.ts'
import { CONTACT_MAIL, CONTACT_TELEPHONE, getAboutList, getCooperationList } from '@/config/config.ts'
const { t } = useTranslations()

const cooperationList = computed(() => getCooperationList(t))
const aboutList = computed(() => getAboutList(t))

const currentYear = new Date().getFullYear()

const getMenuItem = (text: string, href: string) =>
  h('li',
    { class: 'text-[18px] font-normal leading-[36px] text-light-grey' },
    h('a', { href, target: '_blank', rel: 'noopener noreferrer', class: 'hover:text-yellow-custom' }, text),
  )
</script>

<template>
  <footer class="bg-purple-custom text-white py-8 px-4 md:px-8 pt-14 mt-7">
    <div class="mx-auto max-w-[1200px]">
      <div class="flex items-center flex-wrap gap-8 justify-start sm:justify-around">
        <div class="flex flex-col justify-between max-w-[400px]">
          <div>
            <img
              src="/crowdy-logo-white2.png"
              alt="Crowdy.ai Logo"
              width="190"
              height="37"
            />

            <p class="text-sm text-light-grey font-inter text-[16px] font-normal leading-[24px] mt-5 mb-4">
              {{ t('footer.description') }}
            </p>
          </div>

          <div class="flex items-center flex-row flex-wrap justify-between gap-6">
            <div class="flex items-center gap-6">
              <div class="flex items-center justify-center w-9 h-9 bg-light-grey rounded-[50px] text-purple-custom">
                <font-awesome-icon :icon="['fas', 'phone']" />
              </div>
              <a :href="`tel:${CONTACT_TELEPHONE}`" target="_blank"  rel="noopener noreferrer" class="block text-[18px] font-medium hover:text-yellow-custom">
               {{ CONTACT_TELEPHONE }}
              </a>
            </div>

            <div class="flex items-center gap-6">
              <div class="flex items-center justify-center w-9 h-9 bg-light-grey rounded-[50px] text-purple-custom">
                <font-awesome-icon :icon="['fas', 'envelope']"/>
              </div>
              <a :href="`mailto:${CONTACT_MAIL}`" target="_blank" rel="noopener noreferrer" class="block text-[18px] font-medium hover:text-yellow-custom">
                {{ CONTACT_MAIL }}
              </a>
            </div>
          </div>
        </div>

        <div>
          <div class="text-white p-0 mb-[20px] font-inter text-[24px] font-semibold leading-[39px] text-left">
            {{ t('footer.termsCooperation') }}
          </div>
          <component
            v-for="(item, index) in cooperationList"
            :key="index"
            :is="getMenuItem(item.text, item.href)"
          />
        </div>

        <div>
          <div class="text-white p-0 mb-[20px] font-inter text-[24px] font-semibold leading-[39px] text-left">
            Crowdy.ai
          </div>
          <component
            v-for="(item, index) in aboutList"
            :key="index"
            :is="getMenuItem(item.text, item.href)"
          />
        </div>
      </div>

      <div class="mt-8 border-t border-white/20 pt-4 flex items-center justify-around">
        <p class="text-sm">&copy; {{ currentYear }} Crowdy.ai. {{ t('footer.rightsReserved') }}</p>
      </div>
    </div>
  </footer>
</template>

<style scoped></style>
